import { render, staticRenderFns } from "./formula-assets-info.html?vue&type=template&id=f412f844&scoped=true&external"
import script from "./formula-assets-info.js?vue&type=script&lang=js&external"
export * from "./formula-assets-info.js?vue&type=script&lang=js&external"
import style0 from "./formula-assets-info.scss?vue&type=style&index=0&id=f412f844&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f412f844",
  null
  
)

export default component.exports